module.exports = __webpack_public_path__ + "assets/img/CONN.webp?2dffd1d9eaecce128404e1b1587744d8";